// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { alphabetNavigationStyles } from "@sc/Overrides/Widgets/Brand/AlphabetNavigation";
import Search from "@sc/XDL/Icons/Search";
import { color, getSystemColor, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

alphabetNavigationStyles.container = {
    css: css`
        padding: 13px;
        border-radius: 4px;
        border: 1px solid ${color("common.border")};
    `,
};

alphabetNavigationStyles.brandsLettersWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 16px;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

alphabetNavigationStyles.selectWrapper = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            width: 100%;
            display: flex;
        }
    `,
};

alphabetNavigationStyles.select = {
    labelProps: {
        css: css`
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            &&&& {
                ${xScreen("lte", "md")} {
                    margin-top: 0;
                }
            }
        `,
    },
};

alphabetNavigationStyles.alphabetSection = {
    css: css`
        display: flex;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

alphabetNavigationStyles.alphabetContainer = {
    css: css`
        display: flex;
        gap: 9px;
        flex-wrap: wrap;
    `,
};

alphabetNavigationStyles.filterSection = {
    css: css`
        display: flex;
        width: 50%;
        max-width: 644px;

        ${xScreen("lte", "md")} {
            width: 100%;
            max-width: unset;
        }
    `,
};

alphabetNavigationStyles.filterInput = {
    iconProps: {
        src: Search,
        color: "primary.main",
    },
    labelProps: {
        size: 16,
        weight: 700,
        css: css`
            line-height: 22px;
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            &&&& {
                ${xScreen("lte", "md")} {
                    margin-top: 0;
                }
            }
        `,
    },
};

alphabetNavigationStyles.navigationItem = {
    css: css`
        > p {
            font-size: 16px;
            line-height: 17px;
        }
        > button {
            display: flex;
        }
    `,
};

alphabetNavigationStyles.titleText = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 17px;
    `,
};

alphabetNavigationStyles.navigationLink = {
    mergeCss: true,
    typographyProps: {
        transform: "capitalize",
        lineHeight: "19px",
        size: 16,
    },
    css: css`
        ${TypographyStyle} {
            padding: 0;
            line-height: 17px;
            color: ${getSystemColor("primary.main")};
            ${({ lastLetterClicked }: any) => {
                return lastLetterClicked
                    ? css`
                          text-decoration: underline;
                      `
                    : "";
            }}
        }
    `,
};
